"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCaseToText = exports.lowercaseTextToId = exports.jsonReviver = void 0;
var moment_1 = __importDefault(require("moment"));
var isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
var jsonReviver = function (_, value) {
    if (typeof value !== "string") {
        return value;
    }
    if (isoDateRegex.exec(value)) {
        return (0, moment_1.default)(value).toDate();
    }
    return value;
};
exports.jsonReviver = jsonReviver;
var lowercaseTextToId = function (text) {
    var spaceToUnderscore = text.replace(/ /g, "_");
    var newText = spaceToUnderscore.toLowerCase();
    return newText;
};
exports.lowercaseTextToId = lowercaseTextToId;
var camelCaseToText = function (text) {
    return text
        .split(/(?=[A-Z])/)
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(" ");
};
exports.camelCaseToText = camelCaseToText;
//# sourceMappingURL=utils.js.map